<template>
  <div class="guess-container">
    <el-button type="three" size="medium" @click="add">添加问题</el-button>
    <el-table
      :data="questionLists"
      style="width: 100%"
      :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
      :cell-style="{
        background: '#FCFDFF',
        'font-size': '14px',
        color: '#8998AC',
      }"
    >
      <el-table-column
        prop="question_name"
        label="问题名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ans_text"
        label="问题回复"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <my-operation
            :scope="scope"
            @add="add"
            @deleteItem="deleteItem"
          ></my-operation>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="10"
      layout="total, prev, pager, next, jumper"
      :total="total"
      prev-text="上一页"
      next-text="下一页"
      v-if="total > 10"
    >
    </el-pagination>
    <el-dialog
      :close-on-click-modal="false"
      :title="`${opeType == 'add' ? '添加问题' : '修改问题'}`"
      :visible.sync="isOpened"
      width="800px"
      :before-close="closeDialog"
    >
      <el-form
        :model="questionForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="left"
      >
        <el-form-item label="推荐问题：">
          <el-input
            v-model="questionForm.question_name"
            placeholder="请输入问题"
          ></el-input>
        </el-form-item>
        <el-form-item label="回复内容：">
          <el-input
            v-model="questionForm.ans_text"
            type="textarea"
            placeholder="请输入回复内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input-number
            v-model="questionForm.sort"
            :min="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" round @click="closeDialog">取消</el-button>
        <el-button size="medium" round type="primary" @click="confirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { isSuccess } from '@/utils/index'
  import { getGuessList, deleteGuess, addGuess } from '@/api/setBase'
  export default {
    components: {
      'my-operation': () => import('@/components/operation/index.vue'),
    },
    data() {
      return {
        questionLists: [],
        questionForm: {
          question_name: '',
          sort: 1,
          ans_text: '',
        },
        total: 0,
        currentPage: 1,
        isOpened: false,
        opeType: 'add',
        num: 1,
      }
    },
    mounted() {
      this.getLists()
    },
    methods: {
      async getLists() {
        const res = await getGuessList({ page: this.currentPage })
        this.questionLists = res.data.list
        this.total = res.data.total
      },
      handleCurrentChange() {
        this.getLists()
      },
      add(row) {
        if (row.id) {
          this.questionForm = {
            id: row.id,
            question_name: row.question_name,
            ans_text: row.ans_text,
            sort: row.sort,
          }
        }

        this.isOpened = true
      },
      async deleteItem(row) {
        const res = await deleteGuess({
          id: row.id,
        })
        if (isSuccess(res.code)) {
          if (this.questionLists.length == 1) {
            this.currentPage -= 1
          }
          this.$message.success('删除成功')
          this.getLists()
          return
        }
      },
      closeDialog() {
        this.isOpened = false
        this.questionForm = {
          question_name: '',
          sort: 1,
          ans_text: '',
        }
      },
      async confirm() {
        const res = await addGuess(this.questionForm)
        if (isSuccess(res.code)) {
          this.$message.success(res.message)
          this.getLists()
          this.closeDialog()
          return
        }
      },
    },
  }
</script>

<style lang="scss"></style>
